import type { Entity } from '@backstage/catalog-model';

/**
 * Visual categories used to color catalog graph nodes by entity type.
 *
 * Grounded in the real classification produced by the Sheriff catalog
 * generator (vw-bitbucket-scan): kind: Component + spec.type "service"/
 * "website" for backend/frontend, and kind: Resource for everything else
 * infra-related (terraform/helm/kubernetes/database/ansible/generic).
 */
export type NodeCategory = 'backend' | 'frontend' | 'resource';

export const NODE_CATEGORY_LABELS: Record<NodeCategory, string> = {
  backend: 'Backend',
  frontend: 'Frontend',
  resource: 'Resource',
};

export const NODE_CATEGORY_COLORS: Record<
  NodeCategory,
  { light: string; dark: string }
> = {
  backend: { light: '#2a78d6', dark: '#3987e5' },
  frontend: { light: '#eb6834', dark: '#d95926' },
  resource: { light: '#1baf7a', dark: '#199e70' },
};

export function getNodeCategory(entity?: Entity): NodeCategory | undefined {
  if (!entity) {
    return undefined;
  }

  if (entity.kind === 'Resource') {
    return 'resource';
  }

  if (entity.kind === 'Component') {
    const type = (entity.spec as { type?: unknown } | undefined)?.type;

    if (type === 'service') {
      return 'backend';
    }

    if (type === 'website') {
      return 'frontend';
    }
  }

  return undefined;
}
